import { useQuery } from '@tanstack/react-query';
import useGraphQLClient from '../../../app/hooks/useGraphQLClient';
import { useAuthContext } from '../../auth/contexts/AuthContext';
import { gql } from 'graphql-request';
import AppError from '../../../app/features/error/services/AppError';
import IEmailNotification from '../interfaces/IEmailNotification';

const useEmailNotifications = () => {
	const graphQLClient = useGraphQLClient();
	const auth = useAuthContext();

	return useQuery<IEmailNotification[], Error>(
		['emailNotifications'],
		async () => {
			try {
				const data = (await graphQLClient.request(
					gql`
						query {
							notifications {
								fund {
									id
									name
								}
								document {
									id
									name
								}
								documentCompany {
									id
									name
								}
								documentReleaseDate
								user {
									id
									firstName
									lastName
									email
								}
								notification {
									id
									subject
									cc
									sendDatetime
									status
									statusTag
									sendStatus
								}
							}
						}
					`,
				)) as { notifications: IEmailNotification[] };
				return data.notifications;
			} catch (e) {
				throw new AppError(e, 'useEmailNotifications');
			}
		},
		{
			enabled: auth.authContext === 'employee' && auth.isAuthenticated && !auth.authOverrideUserId,
		},
	);
};

export default useEmailNotifications;
